var nativeCreate = require('./_nativeCreate');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;



//////////////////
// WEBPACK FOOTER
// ./~/victory-cursor-container/~/lodash/_hashClear.js
// module id = ./node_modules/victory-cursor-container/node_modules/lodash/_hashClear.js
// module chunks = 1